@if (alert) {
  <div
    class="alert-container"
    [ngClass]="{
      'alert-error': alert.type === 'error',
      'alert-success': alert.type === 'success',
      'alert-warning': alert.type === 'warning',
      show: show,
    }"
    (mouseenter)="holdOpen()"
    (mouseleave)="releaseHold()"
  >
    <div class="alert container">
      <div class="row">
        <div class="col-auto align-self-center">
          <div class="alert-icon-container">
            @if (alert.type === 'success') {
              <div class="alert-icon" [inlineSVG]="'/icons/icon-success.svg'"></div>
            }
            @if (alert.type === 'error' || alert.type === 'warning') {
              <div class="alert-icon" [inlineSVG]="'/icons/icon-error.svg'"></div>
            }
          </div>
        </div>
        <div class="col p-0 alert-message align-self-center">
          @if (alert.title) {
            <div class="title">
              @if (alert.title.translate) {
                {{ alert.title.message | transloco }}
              }
              @if (!alert.title.translate) {
                {{ alert.title.message }}
              }
              @if (alert.requestId) {
                <span class="request-id">Id: {{ alert.requestId }}</span>
              }
              @if (canReport) {
                <button type="button" class="report-error" (click)="report()">
                  {{ 'alert.report.action' | transloco }}
                </button>
              }
            </div>
          }
          @if (alert.message) {
            <div class="message" #message>
              @if (alert.message.translate) {
                {{ alert.message.message | transloco: alert.message.params }}
              }
              @if (!alert.message.translate) {
                <span [innerHTML]="alert.message.message"></span>
              }
            </div>
          }
        </div>
        <div class="col-auto align-self-center">
          <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeAlert()"></div>
        </div>
      </div>
    </div>
  </div>
}
